import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  "class": "d-flex align-items-start"
};
var _hoisted_2 = {
  "class": "flex-grow-1 ms-3 placeholder-glow"
};
var _hoisted_3 = {
  "class": "d-flex align-items-center"
};
var _hoisted_4 = {
  "class": "placeholder-glow d-flex flex-column mt-2"
};
export default {
  __name: 'ThreadLoader',
  props: {
    variant: {
      type: String,
      "default": ''
    }
  },
  setup: function setup(__props) {
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", {
        "class": _normalizeClass([{
          'mx-n3 px-3': __props.variant === 'mobile'
        }, "loader position-relative text-decoration-none sh-text-black py-3 px-2 pe-5"])
      }, [_createElementVNode("div", _hoisted_1, [_cache[1] || (_cache[1] = _createElementVNode("div", {
        "class": "flex-shrink-0 placeholder-glow"
      }, [_createElementVNode("span", {
        "class": "icon rounded-circle placeholder sh-background-gray-blueish"
      })], -1)), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("span", {
        "class": _normalizeClass([{
          'rounded-pill': __props.variant !== 'mobile'
        }, "placeholder col-3 placeholder-xs sh-background-gray-blueish"])
      }, null, 2)]), _createElementVNode("div", _hoisted_4, [_createElementVNode("span", {
        "class": _normalizeClass([{
          'rounded-pill': __props.variant !== 'mobile'
        }, "placeholder col-12 placeholder-xs sh-background-gray-blueish mb-1"])
      }, null, 2), _cache[0] || (_cache[0] = _createElementVNode("span", {
        "class": "placeholder col-7 placeholder-xs sh-background-gray-blueish rounded-pill"
      }, null, -1))])])])], 2);
    };
  }
};